import { useQuery } from '@tanstack/vue-query'
import type { ComputedRef } from 'vue'
import { computed } from 'vue'

import useAccount from '@/features/auth/hooks/use-account.hook'
import { selectGetSelectedProgramId } from '@/features/programs/stores/programs/programs.selectors'
import programsStore from '@/features/programs/stores/programs/programs.store'
import { getUserProgramRoles, V1_USER_PROGRAM_ROLES_QUERY_KEY } from '@/features/users/api'

function useProgramRoles({ programIdRef }: { programIdRef?: ComputedRef<string | null | undefined> } = {}) {
  const { accountRef } = useAccount()
  const selectedProgramIdRef = selectGetSelectedProgramId(programsStore)
  const usedProgramIdRef = computed(() => programIdRef?.value || selectedProgramIdRef.value!)
  const accountIdRef = computed(() => accountRef.value?.id)
  const isProgramQueryEnabledRef = computed(() => !!usedProgramIdRef.value && !!accountIdRef?.value)

  const queryResult = useQuery({
    queryKey: [V1_USER_PROGRAM_ROLES_QUERY_KEY, { programId: usedProgramIdRef, userId: accountIdRef }],
    queryFn: () => getUserProgramRoles({ programId: usedProgramIdRef.value!, userId: accountIdRef.value! }),
    enabled: isProgramQueryEnabledRef,
  })

  // merging all data from the queries (that constitute the account data)
  const programRolesDataRef = computed(() => {
    return queryResult.data.value?.roles
  })

  // check if any query is pending
  const isPendingRef = computed(() => queryResult.isPending.value)

  return {
    programRolesRef: programRolesDataRef,
    isPendingRef,
  }
}

export default useProgramRoles
